import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { Button, Table, Header, Icon, Form, Segment } from "semantic-ui-react";
import moment from "moment";
import numeral from "numeral";
import feathersConnect from "./../../../providers/feathersConnect";

const INITIAL_STATE = {
  form: {
    loading: false,
    values: {
      filtrarFecha: false,
      proximasCuotas: false,
      fechaVencimiento: moment().format("YYYY-MM-DD"),
      CooperativaId: -1,
      tipo: "all"
    }
  },
  cooperativas: {
    loading: false,
    data: [],
    error: null
  },
  prestamos: {
    loading: false,
    data: [],
    error: null
  },
  reportLayout: false
};

const defaultOptions = [
  {
    key: -1,
    value: -1,
    text: "TODAS"
  }
];

class InformesFinancierosView extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.CooperativaService = this.props.feathers.service("/api/cooperativas");
    this.PrestamoService = this.props.feathers.service("/api/prestamos");
  }

  findCooperativas = () => {
    this.setState(
      {
        cooperativas: {
          ...this.state.cooperativas,
          loading: true
        }
      },
      () => {
        this.CooperativaService.find({ query: { plain: true, sinPagos: true } })
          .then(response => {
            this.setState({
              cooperativas: {
                ...this.state.cooperativas,
                loading: false,
                data: defaultOptions.concat(
                  response.map((coop, index) => ({
                    key: index,
                    text: `${coop.nombre} (${coop.matriculaNacional})`,
                    value: coop.id
                  }))
                )
              }
            });
          })
          .catch(error => {
            this.setState({
              cooperativas: {
                ...this.state.cooperativas,
                loading: false,
                error
              }
            });
          });
      }
    );
  };

  findPrestamos = () => {
    let { form } = this.state;
    let CooperativaId =
      form.values.CooperativaId !== -1 ? form.values.CooperativaId : null;
    let tipo = form.values.tipo !== "all" ? form.values.tipo : undefined;
    let proximosVencimientos = form.values.proximasCuotas || undefined;
    this.setState(
      {
        prestamos: {
          ...this.state.prestamos,
          loading: true
        }
      },
      () => {
        this.PrestamoService.find({
          query: { CooperativaId, simple: true, tipo, proximosVencimientos }
        })
          .then(response => {
            console.log(response);
            this.setState({
              prestamos: {
                ...this.state.prestamos,
                loading: false,
                data: response.records
              }
            });
          })
          .catch(error => {
            console.log(error);
            this.setState({
              prestamos: {
                ...this.state.prestamos,
                loading: false,
                error
              }
            });
          });
      }
    );
  };

  formInputHandler = (e, input) => {
    var name, value;

    if (input) {
      name = input.name;
      if (input.type === "checkbox") {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }
    const other =
      name == "proximasCuotas"
        ? "filtrarFecha"
        : name == "filtrarFecha"
        ? "proximasCuotas"
        : null;
    let values = {
      ...this.state.form.values,
      [name]: value
    };
    if (!!other) {
      values[other] = false;
    }
    this.setState({
      form: {
        ...this.state.form,
        values
      }
    });
  };

  queryReport = e => {
    e.preventDefault();

    if (this.state.cooperativas.loading) {
      return;
    }

    let {
      form: { values }
    } = this.state;

    console.log(values);
    this.findPrestamos();
  };

  toggleReportOutline = () => {
    this.setState(
      {
        reportLayout: !this.state.reportLayout
      },
      () => {
        if (this.state.reportLayout) {
          window.print();
        }
      }
    );
  };

  calcultarSaldoCuota = (transacciones, plain = false) => {
    let saldo = transacciones.reduce(
      (prev, curr) => prev + numeral(curr.monto).value(),
      0
    );

    if (plain) {
      return numeral(saldo).value();
    } else if (saldo < 0) {
      return (
        <span style={{ color: "red" }}>
          <b>{numeral(saldo).format("(0,0.00)")}</b>
        </span>
      );
    } else {
      return numeral(saldo).format("(0,0.00)");
    }
  };

  componentDidMount() {
    this.findCooperativas();
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: path => {
        dispatch(push(path));
      }
    };
  }

  render() {
    const { cooperativas, form, prestamos, reportLayout } = this.state;
    let columns = [];
    let mappedRecords;

    if (form.values.filtrarFecha) {
      mappedRecords = prestamos.data.map((prestamo, index) => {
        const cuotasLength = !!prestamo.cuota
          ? prestamo.cuota.nroCuotas
          : prestamo.cuotas.filter(
              c =>
                moment(c.vencimiento).isSameOrBefore(
                  moment(form.values.fechaVencimiento)
                ) && this.calcultarSaldoCuota(c.transacciones, true) !== 0
            ).length;

        const saldo =
          prestamo.restante ||
          prestamo.cuotas.reduce((prev, curr) => {
            return prev + this.calcultarSaldoCuota(curr.transacciones, true);
          }, 0);

        const saldoVencido =
          prestamo.vencido ||
          prestamo.cuotas
            .filter(c =>
              moment(c.vencimiento).isSameOrBefore(
                moment(form.values.fechaVencimiento)
              )
            )
            .reduce((prev, curr) => {
              return prev + this.calcultarSaldoCuota(curr.transacciones, true);
            }, 0);

        return {
          ...prestamo,
          cuotasLength,
          saldo,
          saldoVencido
        };
      });
    } else {
      mappedRecords = prestamos.data.map((prestamo, index) => {
        const saldo =
          prestamo.restante ||
          prestamo.cuotas.reduce((prev, curr) => {
            return prev + this.calcultarSaldoCuota(curr.transacciones, true);
          }, 0);

        return {
          ...prestamo,
          saldo
        };
      });
    }

    if (reportLayout) {
      mappedRecords = mappedRecords.filter(a => a.saldo != 0);
      return (
        <div>
          <Button
            content="Volver"
            icon="chevron left"
            className="no-print"
            onClick={this.toggleReportOutline}
          />
          <Table basic="very" compact="very" size="small" striped>
            <Table.Header>
              <Table.Row>
                {form.values.filtrarFecha
                  ? [
                      <Table.HeaderCell key={1}>Codigo</Table.HeaderCell>,
                      <Table.HeaderCell key={0}>Entidad</Table.HeaderCell>,
                      <Table.HeaderCell key={2}>Deuda Total</Table.HeaderCell>,
                      <Table.HeaderCell key={3}>
                        Cuotas Vencidas
                      </Table.HeaderCell>,
                      <Table.HeaderCell key={4}>Deuda Vencida</Table.HeaderCell>
                    ]
                  : [
                      <Table.HeaderCell key={1}>Codigo</Table.HeaderCell>,
                      <Table.HeaderCell key={0}>Entidad</Table.HeaderCell>,
                      <Table.HeaderCell key={2}>Cuotas</Table.HeaderCell>,
                      ...(!form.values.proximasCuotas
                        ? []
                        : [
                            <Table.HeaderCell key={4}>
                              Primer Cuota Impaga
                            </Table.HeaderCell>,
                            <Table.HeaderCell key={5}>Moroso</Table.HeaderCell>,
                            <Table.HeaderCell key={6}>
                              Balance Cuota
                            </Table.HeaderCell>,
                            <Table.HeaderCell key={7}>
                              Deuda Vencida
                            </Table.HeaderCell>
                          ]),
                      <Table.HeaderCell key={3}>Deuda Total</Table.HeaderCell>
                    ]}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {form.values.filtrarFecha
                ? mappedRecords.map((prestamo, index) => (
                    <Table.Row key={index}>
                      <Table.Cell style={{ textAlign: "right" }} collapsing>
                        {prestamo.codigo}
                      </Table.Cell>
                      <Table.Cell>{prestamo.cooperativa.nombre}</Table.Cell>
                      <Table.Cell style={{ textAlign: "right" }} collapsing>
                        <span
                          style={{
                            color: prestamo.saldo < 0 ? "red" : "grey"
                          }}>
                          <strong>
                            {numeral(prestamo.saldo).format("(0,0.00)")}
                          </strong>
                        </span>
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "right" }} collapsing>
                        {prestamo.cuotasLength}
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "right" }} collapsing>
                        <span
                          style={{
                            color: prestamo.saldo < 0 ? "red" : "grey"
                          }}>
                          <strong>
                            {numeral(prestamo.saldoVencido).format("(0,0.00)")}
                          </strong>
                        </span>
                      </Table.Cell>
                    </Table.Row>
                  ))
                : mappedRecords.map((prestamo, index) => (
                    <Table.Row key={index}>
                      <Table.Cell collapsing>{prestamo.codigo}</Table.Cell>
                      <Table.Cell>
                        {prestamo.nombreCooperativa ||
                          prestamo.cooperativa.nombre}
                      </Table.Cell>
                      <Table.Cell collapsing>
                        {prestamo.cuota
                          ? prestamo.cuota.nroCuotas
                          : prestamo.cuotas.length}
                      </Table.Cell>
                      {!prestamo.cuota ? null : (
                        <Table.Cell collapsing>
                          {moment(prestamo.cuota.vencimientoCuota).format(
                            "DD/MM/YYYY"
                          )}
                        </Table.Cell>
                      )}
                      {!prestamo.cuota ? null : (
                        <Table.Cell
                          collapsing
                          style={{
                            color: prestamo.moroso ? "red" : undefined
                          }}>
                          {prestamo.moroso ? "MOROSO" : ""}
                        </Table.Cell>
                      )}
                      {!prestamo.cuota ? null : (
                        <Table.Cell
                          collapsing
                          style={{
                            color:
                              prestamo.cuota.balanceCuota < 0
                                ? "red"
                                : undefined
                          }}>
                          {numeral(prestamo.cuota.balanceCuota).format(
                            "(0,0.00)"
                          )}
                        </Table.Cell>
                      )}

                      {!prestamo.cuota ? null : (
                        <Table.Cell
                          collapsing
                          style={{
                            color: prestamo.vencido < 0 ? "red" : undefined
                          }}>
                          {numeral(prestamo.vencido).format("(0,0.00)")}
                        </Table.Cell>
                      )}
                      <Table.Cell collapsing>
                        <span
                          style={{
                            color: prestamo.saldo < 0 ? "red" : "grey"
                          }}>
                          <strong>
                            {numeral(prestamo.saldo).format("(0,0.00)")}
                          </strong>
                        </span>
                      </Table.Cell>
                    </Table.Row>
                  ))}
            </Table.Body>
            <Table.Footer>
              {form.values.filtrarFecha
                ? (() => {
                    const result = numeral(
                      mappedRecords.reduce(
                        (prev, curr) =>
                          numeral(curr.saldoVencido).value() + prev,
                        0
                      )
                    );
                    const resultTotal = numeral(
                      mappedRecords.reduce(
                        (prev, curr) => numeral(curr.saldo).value() + prev,
                        0
                      )
                    );
                    const instalments = mappedRecords.reduce(
                      (prev, curr) => curr.cuotasLength + prev,
                      0
                    );

                    return (
                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={2}
                          style={{ textAlign: "right" }}
                          collapsing
                        />
                        <Table.HeaderCell
                          colSpan={1}
                          style={{ textAlign: "right" }}
                          collapsing>
                          <span
                            style={{
                              color: resultTotal.value() < 0 ? "red" : "grey"
                            }}>
                            <strong>{resultTotal.format("(0,0.00)")}</strong>
                          </span>
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          colSpan={1}
                          style={{ textAlign: "right" }}
                          collapsing>
                          <span
                            style={{
                              color: instalments > 0 ? "red" : "grey"
                            }}>
                            <strong>{instalments}</strong>
                          </span>
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          colSpan={1}
                          style={{ textAlign: "right" }}
                          collapsing>
                          <span
                            style={{
                              color: result.value() < 0 ? "red" : "grey"
                            }}>
                            <strong>{result.format("(0,0.00)")}</strong>
                          </span>
                        </Table.HeaderCell>
                      </Table.Row>
                    );
                  })()
                : (() => {
                    // console.log("mappedRecords", mappedRecords);
                    const result = numeral(
                      mappedRecords.reduce(
                        (prev, curr) => numeral(curr.saldo).value() + prev,
                        0
                      )
                    );
                    const vencida = !form.values.proximasCuotas
                      ? ""
                      : numeral(
                          mappedRecords.reduce(
                            (prev, curr) =>
                              numeral(curr.vencido).value() + prev,
                            0
                          )
                        );
                    const instalments = mappedRecords.reduce((prev, curr) => {
                      // console.log("prev", prev);
                      return curr.cuota
                        ? curr.cuota.nroCuotas + prev
                        : curr.cuotas.length + prev;
                    }, 0);
                    // console.log("instalments", instalments);
                    return (
                      <Table.Row>
                        <Table.HeaderCell colSpan={2} />
                        <Table.HeaderCell
                          colSpan={1}
                          style={{ textAlign: "left" }}
                          collapsing>
                          <span
                            style={{
                              color: instalments > 0 ? "red" : "grey"
                            }}>
                            <strong>{instalments}</strong>
                          </span>
                        </Table.HeaderCell>
                        {!form.values.proximasCuotas ? null : (
                          <Table.HeaderCell colSpan={3} />
                        )}
                        {!form.values.proximasCuotas ? null : (
                          <Table.HeaderCell
                            colSpan={1}
                            style={{ textAlign: "right" }}
                            collapsing>
                            <span
                              style={{
                                color: vencida.value() < 0 ? "red" : "grey"
                              }}>
                              <strong>{vencida.format("(0,0.00)")}</strong>
                            </span>
                          </Table.HeaderCell>
                        )}

                        <Table.HeaderCell
                          colSpan={1}
                          style={{ textAlign: "right" }}
                          collapsing>
                          <span
                            style={{
                              color: result.value() < 0 ? "red" : "grey"
                            }}>
                            <strong>{result.format("(0,0.00)")}</strong>
                          </span>
                        </Table.HeaderCell>
                      </Table.Row>
                    );
                  })()}
            </Table.Footer>
          </Table>
        </div>
      );
    }

    if (form.values.filtrarFecha) {
      columns = [
        {
          Header: "",
          id: "edit",
          width: 32,
          Cell: ({ original: prestamo }) => (
            <div
              style={{
                width: "100%",
                height: "100%",
                textAlign: "center"
              }}>
              <Icon
                className="edit-icon-hover"
                name="location arrow"
                onClick={() =>
                  this.props.navigate(
                    `/cooperativa/${prestamo.CooperativaId}/prestamos/${
                      prestamo.id
                    }`
                  )
                }
              />
            </div>
          ),
          sortable: false,
          resizable: false
        },
        {
          Header: "Entidad",
          id: "entidad",
          accessor: d => d.nombreCooperativa || d.cooperativa.nombre
        },
        {
          Header: "Codigo",
          id: "codigo",
          Cell: ({ original: prestamo }) => (
            <div
              style={{
                width: "100%",
                height: "100%",
                textAlign: "right"
              }}>
              <div
                style={{
                  width: `100%`,
                  height: "100%"
                }}>
                {prestamo.codigo}
              </div>
            </div>
          ),
          width: 72
        },
        {
          Header: "Deuda Total",
          id: "saldo",
          Cell: ({ original: prestamo }) => {
            const saldo =
              prestamo.restante ||
              prestamo.cuotas.reduce((prev, curr) => {
                return (
                  prev + this.calcultarSaldoCuota(curr.transacciones, true)
                );
              }, 0);

            return (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  textAlign: "right"
                }}>
                <div
                  style={{
                    width: `100%`,
                    height: "100%"
                  }}>
                  <span style={{ color: saldo < 0 ? "red" : "grey" }}>
                    <strong>{numeral(saldo).format("(0,0.00)")}</strong>
                  </span>
                </div>
              </div>
            );
          },
          width: 128,
          sortable: false
        },
        {
          Header: `Cuotas vencidas`,
          width: 128,
          id: "cuotas",
          Cell: ({ original: prestamo }) => {
            const cuotasLength = !prestamo.cuotas
              ? ""
              : prestamo.cuotas.filter(
                  c =>
                    moment(c.vencimiento).isSameOrBefore(
                      moment(form.values.fechaVencimiento)
                    ) && this.calcultarSaldoCuota(c.transacciones, true) !== 0
                ).length;

            return (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  textAlign: "right"
                }}>
                <div
                  style={{
                    width: `100%`,
                    height: "100%"
                  }}>
                  {cuotasLength}
                </div>
              </div>
            );
          },
          sortable: false
        },
        {
          Header: `Saldo vencido ${moment(form.values.fechaVencimiento).format(
            "DD/MM/YYYY"
          )}`,
          id: "saldo",
          Cell: ({ original: prestamo }) => {
            const saldo =
              prestamo.vencido ||
              prestamo.cuotas
                .filter(c =>
                  moment(c.vencimiento).isSameOrBefore(
                    moment(form.values.fechaVencimiento)
                  )
                )
                .reduce((prev, curr) => {
                  return (
                    prev + this.calcultarSaldoCuota(curr.transacciones, true)
                  );
                }, 0);

            return (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  textAlign: "right"
                }}>
                <div
                  style={{
                    width: `100%`,
                    height: "100%"
                  }}>
                  <span style={{ color: saldo < 0 ? "red" : "grey" }}>
                    <strong>{numeral(saldo).format("(0,0.00)")}</strong>
                  </span>
                </div>
              </div>
            );
          },
          wdith: 128,
          sortable: false
        }
      ];
    } else {
      columns = [
        {
          Header: "",
          width: 32,
          id: "edit",
          Cell: ({ original: prestamo }) => (
            <div
              style={{
                width: "100%",
                height: "100%",
                textAlign: "center"
              }}>
              <Icon
                className="edit-icon-hover"
                name="location arrow"
                onClick={() =>
                  this.props.navigate(
                    `/cooperativa/${prestamo.CooperativaId}/prestamos/${
                      prestamo.id
                    }`
                  )
                }
              />
            </div>
          ),
          sortable: false,
          resizable: false
        },
        {
          Header: "Entidad",
          id: "entidad",
          accessor: d => d.nombreCooperativa || d.cooperativa.nombre
        },
        ...(!form.values.proximasCuotas
          ? []
          : [
              {
                Header: "Vencimiento Cuota Impaga",
                id: "vencimientoCuota",
                accessor: d =>
                  d.cuota
                    ? moment(d.cuota.vencimientoCuota).format("DD/MM/YYYY")
                    : ""
              },
              {
                Header: "Moroso",
                id: "moroso",
                maxWidth: 80,
                accessor: d =>
                  typeof d.moroso == "boolean" ? (d.moroso ? "Sí" : "No") : ""
              },
              {
                Header: "Saldo Restante Cuota",
                id: "saldoRestanteCuota",
                accessor: d => (!d.cuota ? "" : d.cuota.balanceCuota),
                Cell: ({ original: prestamo, value }) => {
                  const saldo =
                    prestamo.restante ||
                    prestamo.cuotas.reduce((prev, curr) => {
                      return (
                        prev +
                        this.calcultarSaldoCuota(curr.transacciones, true)
                      );
                    }, 0);

                  return (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        textAlign: "right"
                      }}>
                      <div
                        style={{
                          width: `100%`,
                          height: "100%"
                        }}>
                        <span style={{ color: value < 0 ? "red" : "grey" }}>
                          <strong>
                            {prestamo.cuota
                              ? numeral(value).format("(0,0.00)")
                              : ""}
                          </strong>
                        </span>
                      </div>
                    </div>
                  );
                }
              }
            ]),
        // {
        //   Header: "Codigo",
        //   accessor: "codigo",
        //   width: 72
        // },
        {
          Header: "Cuotas",
          width: 64,
          id: "cuotas",
          Cell: ({ original: prestamo }) => (
            <div
              style={{
                width: "100%",
                height: "100%",
                textAlign: "right"
              }}>
              <div
                style={{
                  width: `100%`,
                  height: "100%"
                }}>
                {prestamo.cuota
                  ? prestamo.cuota.nroCuotas
                  : prestamo.cuotas.length}
              </div>
            </div>
          ),
          sortable: false
        },
        {
          Header: "Deuda Total",
          id: "saldo",
          Cell: ({ original: prestamo }) => {
            const saldo =
              prestamo.restante ||
              prestamo.cuotas.reduce((prev, curr) => {
                return (
                  prev + this.calcultarSaldoCuota(curr.transacciones, true)
                );
              }, 0);

            return (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  textAlign: "right"
                }}>
                <div
                  style={{
                    width: `100%`,
                    height: "100%"
                  }}>
                  <span style={{ color: saldo < 0 ? "red" : "grey" }}>
                    <strong>{numeral(saldo).format("(0,0.00)")}</strong>
                  </span>
                </div>
              </div>
            );
          },
          width: 128,
          sortable: false
        }
      ];
    }

    return (
      <div>
        <Form onSubmit={this.queryReport}>
          <Form.Group>
            <Form.Checkbox
              name="filtrarFecha"
              label="Filtrar Decha"
              checked={form.values.filtrarFecha}
              onChange={this.formInputHandler}
            />
            <Form.Input
              name="fechaVencimiento"
              label="Vencimiento"
              type="date"
              disabled={!form.values.filtrarFecha}
              value={form.values.fechaVencimiento}
              onChange={this.formInputHandler}
            />
            <Form.Checkbox
              name="proximasCuotas"
              label="Informe de Morosos y Proximas Cuotas"
              checked={form.values.proximasCuotas}
              onChange={this.formInputHandler}
            />
          </Form.Group>
          <Form.Group>
            <Form.Select
              name="CooperativaId"
              loading={cooperativas.loading}
              search
              options={cooperativas.data}
              width={6}
              value={form.values.CooperativaId}
              onChange={this.formInputHandler}
            />
            <Form.Select
              name="tipo"
              loading={cooperativas.loading}
              options={[
                { key: "all", text: "Todo", value: "all" },
                { key: "PRESTAMO", value: "PRESTAMO", text: "Prestamos" },
                { key: "SUBSIDIO", value: "SUBSIDIO", text: "Subsidios" }
              ]}
              width={4}
              value={form.values.tipo}
              onChange={this.formInputHandler}
            />
            <Form.Button
              disabled={cooperativas.loading}
              icon="refresh"
              content="Buscar"
              primary
              onClick={this.queryReport}
            />
            <Form.Button
              disabled={prestamos.loading || prestamos.data.length === 0}
              icon="file"
              content="Reporte"
              secondary
              onClick={this.toggleReportOutline}
            />
          </Form.Group>
        </Form>
        <ReactTable
          className="-striped -highlight"
          loading={prestamos.loading}
          noDataText={"Sin Registros"}
          loadingText={"Cargando..."}
          defaultPageSize={10}
          pageSizeOptions={[10]}
          data={prestamos.data}
          previousText={"<<<"}
          nextText={">>>"}
          pageText={"Pagina"}
          ofText={"de"}
          rowsText={"filas"}
          columns={columns}
        />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    InformesFinancierosView.mapStateToProps,
    InformesFinancierosView.mapDispatchToProps
  )(InformesFinancierosView)
);



// WEBPACK FOOTER //
// ./client/components/pages/financiero/InformesFinancierosView.js